/**
 * NBL Independence Day Sale — sale-landing-page.js
 * Upload to: Shopify Admin > Online Store > Themes > Assets
 *
 * Handles:
 *  - Live countdown timer to sale end (July 7, 2026 00:00 EST = UTC 05:00)
 *  - Smooth scroll for the hero CTA anchor link
 */

(function () {
  'use strict';

  /* ============================================================
     COUNTDOWN TIMER
     Sale ends: July 7, 2026 at 00:00 EST (= 05:00 UTC)
     ============================================================ */
  var SALE_END_UTC = new Date('2026-07-07T05:00:00Z');

  var elDays  = document.getElementById('nbl-cd-days');
  var elHours = document.getElementById('nbl-cd-hours');
  var elMins  = document.getElementById('nbl-cd-mins');
  var elSecs  = document.getElementById('nbl-cd-secs');
  var elWrap  = document.getElementById('nbl-countdown-wrap');

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function updateCountdown() {
    var now  = new Date();
    var diff = SALE_END_UTC - now;

    if (diff <= 0) {
      if (elWrap) {
        elWrap.innerHTML =
          '<div style="color:rgba(255,255,255,0.7);font-size:16px;font-weight:700;">' +
          'Sale has ended. Check back for future deals!' +
          '</div>';
      }
      return;
    }

    var days  = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins  = Math.floor((diff % 3600000)  / 60000);
    var secs  = Math.floor((diff % 60000)    / 1000);

    if (elDays)  elDays.textContent  = pad(days);
    if (elHours) elHours.textContent = pad(hours);
    if (elMins)  elMins.textContent  = pad(mins);
    if (elSecs)  elSecs.textContent  = pad(secs);
  }

  // Run immediately so there's no flash of "00 00 00 00"
  updateCountdown();
  setInterval(updateCountdown, 1000);


  /* ============================================================
     SMOOTH SCROLL — hero "Shop All Deals ↓" CTA
     Works even if the theme doesn't have scroll-behavior: smooth
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    var ctaLink = document.querySelector('.nbl-hero-cta[href="#nbl-products"]');
    if (!ctaLink) return;

    ctaLink.addEventListener('click', function (e) {
      var target = document.getElementById('nbl-products');
      if (!target) return;

      e.preventDefault();

      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - 16;

      // Use native smooth scroll if supported
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: targetTop, behavior: 'smooth' });
      } else {
        // Fallback for older browsers
        var start     = window.pageYOffset;
        var distance  = targetTop - start;
        var duration  = 600; // ms
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var elapsed  = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          // Ease-in-out quad
          var ease = progress < 0.5
            ? 2 * progress * progress
            : -1 + (4 - 2 * progress) * progress;

          window.scrollTo(0, start + distance * ease);
          if (elapsed < duration) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
      }
    });
  });

})();
